import i18next from 'i18next';
import { Consts } from "../res";
import { store } from '../store';
import { isPassed } from './examScore';

const { getState } = store;

export const resolveExam = (examType, topic, examId) => {
    const exams = getState().userCourses.selectedCourseStruct.allowedExams;
    if (!exams || !exams.length) return null;
    if (examId) return getExamByExamId(examId);
    if (topic) return exams.find(e => e.type === examType && e.topicId === topic) || null;
    return exams.find(e => e.type === examType) || null;
};

export const getExamTypeString = (type, orderNum) => {
    switch (type) {
        case Consts.EXAM_TYPES.MCQS: return i18next.t('McqsBank');
        case Consts.EXAM_TYPES.ESSAY: return i18next.t('EssaysBank');
        case Consts.EXAM_TYPES.TBS: return i18next.t('TbsBank');
        case Consts.EXAM_TYPES.FILE: return i18next.t('FileBank');
        case Consts.EXAM_TYPES.TEST_MCQS:
            return i18next.t('TestKnowledge') + "-" + i18next.t("MCQS");
        case Consts.EXAM_TYPES.TEST_ESSAY:
            return i18next.t('TestKnowledge') + "-" + i18next.t("Essay");
        case Consts.EXAM_TYPES.TEST_TBS:
            return i18next.t('TestKnowledge') + "-" + i18next.t("Tbs");
        case Consts.EXAM_TYPES.TEST_FILE:
            return i18next.t('TestKnowledge') + "-" + i18next.t("File");
        case Consts.EXAM_TYPES.FREQ:
            return `${i18next.t('Section')} ${orderNum}`;
        default:
            return i18next.t('TestKnowledge');
    }
};

export const getQuestionTypeString = (type) => {
    switch (type) {
        case Consts.QUESTIONS_TYPES.MCQS: return i18next.t('MCQS');
        case Consts.QUESTIONS_TYPES.ESSAY: return i18next.t('Essay');
        case Consts.QUESTIONS_TYPES.COMPOSITE: return i18next.t('Tbs');
        case Consts.QUESTIONS_TYPES.File: return i18next.t('File');
        default: return "";
    }
};


export const getExamByExamId = (examId) => {
    const exams = getState().userCourses.selectedCourseStruct.allowedExams;
    const freqExamList = exams?.filter(e => (e.type === Consts.EXAM_TYPES.FREQ_PARENT || e.type === Consts.EXAM_TYPES.FREQ));

    for (let i = 0; i < freqExamList?.length; i++) {
        if (freqExamList[i].id === examId) return freqExamList[i];
        else {
            const e = freqExamList[i]?.childs?.find(ex => ex.id === examId);
            if (e) return e;
        }
    }
    return null;
};

export const findNextFreqExam = (parentId, orderNum) => {
    const exams = getState().userCourses.selectedCourseStruct.allowedExams;
    const freqExam = exams.find(e => e.id === parentId);
    return freqExam?.childs?.[orderNum];
};

export const findFreqExamByType = (parentId, type) => {
    const exams = getState().userCourses.selectedCourseStruct.allowedExams;
    const freqExam = exams.find(e => e.id === parentId);
    const exam = freqExam?.childs?.find(e => e.questionsTypeId === type);
    return exam;
};

export const findExamByTopicId = (topicId) => {
    const exams = getState().userCourses.selectedCourseStruct.allowedExams;
    const exam = exams.find(e => e.topicId === topicId);
    return exam;
};

export const ResultCalculator = (questions) => {
    const res = {
        correctAnswers: 0,
        wrongAnswers: 0,
        notAnswered: 0,
        flaggedQuestions: 0,
        questions: 0
    };

    questions.forEach(q => {

        if (!q.answerOptionId || !q.correctAnswer)
            res.notAnswered++;
        else if (q.correctAnswer && q.correctAnswer.correctAnswerOptionId === q.answerOptionId)
            res.correctAnswers++;
        else res.wrongAnswers++;

        if (q.isFlagged)
            res.flaggedQuestions++;
    });

    res.questions = questions.length;

    return [
        { label: 'correctAnswers', correctAnswers: res.correctAnswers },
        { label: 'wrongAnswers', wrongAnswers: res.wrongAnswers },
        { label: 'notAnswered', notAnswered: res.notAnswered },
        { label: 'flaggedQuestions', flaggedQuestions: res.flaggedQuestions },
        { label: 'questions', questions: res.questions },
    ];
};


/*
 * Whether a marked round passed. The rule itself is `examScore.js`'s, shared
 * with the student's reports, which used to judge the same round by a rounding
 * of their own. The old body here also held the pass mark as a string, which
 * compares as text the day the grade arrives as one ("8.5" >= "36").
 */
export const calcResult = (round) => isPassed(round);

export const showRes = (exam) => {
    if (!exam.isFullCorrected) return i18next.t('Pending');
    return calcResult(exam) ? i18next.t('Passed') : i18next.t('Failed');
};